import React from 'react';
import PropTypes from 'prop-types';


export default class Accordion extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        htmlDescription: PropTypes.string,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ]),
        modifierClass: PropTypes.array
    }

    static defaultProps = {
        title: '',
        children: [],
        description: '',
        htmlDescription: '',
        modifierClass: []
    };


    render() {

        const description = this.props.htmlDescription !== '' ?
            <div dangerouslySetInnerHTML={{ __html: this.props.htmlDescription }} />
            : <p>{this.props.description}</p>;

        return (
            <div className="insurance insurance--member-info insurance--visible-overflow">
                <div className="insurance__content">
                    <h1>{this.props.title}</h1>
                    {description}
                </div>
                <div className="insurance__accordion">
                    <ul className="insurance__accordion__list">
                        {this.props.children}
                    </ul>
                </div>
            </div>
        );
    }
};

